import(/* webpackMode: "eager", webpackExports: ["Container"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/container/container.js");
